export const StopTouchEvent = () => {
    var directive: ng.IDirective = {
        restrict: 'A',
        link
    };

    return directive;    
        
    // define the link function in this closure directive injectables are in-scope
    function link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes){
        element.on('touchmove', function (evt) {
            evt.stopPropagation();
        });
    }    
};

StopTouchEvent.$inject = [];


// WEBPACK FOOTER //
// ./src/util/services/stopTouchEvent.ts